import SocialNetworkPage from './SocialNetworkPage';
export default SocialNetworkPage;
